import { render, staticRenderFns } from "./RechargeMain.vue?vue&type=template&id=6150b258&scoped=true&"
import script from "./RechargeMain.vue?vue&type=script&lang=js&"
export * from "./RechargeMain.vue?vue&type=script&lang=js&"
import style0 from "./RechargeMain.vue?vue&type=style&index=0&id=6150b258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6150b258",
  null
  
)

export default component.exports